import { gallery } from '../content/site';
import SectionHeading from './SectionHeading';

export default function Gallery() {
  return (
    <section id="gallery" className="bg-dusk py-24 text-cream">
      <div className="container-page">
        <SectionHeading eyebrow={gallery.eyebrow} heading={gallery.heading} align="center" />
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm text-cream/70">{gallery.description}</p>

        <div className="mt-12 grid grid-cols-2 gap-6 sm:grid-cols-4">
          {gallery.placeholders.map((item) => (
            <div
              key={item.label}
              className="flex aspect-square flex-col items-center justify-center rounded-xl2 border border-dashed border-cream/20 p-4 text-center"
            >
              <p className="font-display text-base text-cream sm:text-lg">{item.label}</p>
              <p className="mt-1 text-xs text-cream/50">{item.caption}</p>
              <span className="mt-3 rounded-full bg-cream/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-cream/60">
                Coming soon
              </span>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href={gallery.cta.href}
            className="inline-flex rounded-full bg-coral px-6 py-3 text-sm font-semibold text-cream shadow-soft transition-colors hover:bg-coral-dark"
          >
            {gallery.cta.label}
          </a>
        </div>
      </div>
    </section>
  );
}
